import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';
/* empty css                                                                    */
/* empty css                                                                                */
import Keyboard from '../../vendor/swiper/modules/keyboard.mjs';
import Navigation from '../../vendor/swiper/modules/navigation.mjs';
import Pagination from '../../vendor/swiper/modules/pagination.mjs';
import A11y from '../../vendor/swiper/modules/a11y.mjs';
import { Swiper } from '../../vendor/swiper/swiper-react.mjs';
import { LineIcon } from '../ui/icons/LineIcon.js';

const AccessibleSwiper = ({
  children,
  className,
  pagination,
  showNavigation = true,
  multiClass = "",
  onSlideChange,
  ...props
}) => {
  const { isDesktop } = useDevice();
  const multiId = useId().replace(/:/g, "") + multiClass;
  const updatePagination = (swiper) => {
    const bullets = swiper.pagination.bullets;
    bullets.forEach((el, i) => {
      if (i === swiper.activeIndex) {
        el.setAttribute("aria-current", "true");
      } else {
        el.removeAttribute("aria-current");
      }
    });
  };
  const handleSlideChange = (swiper) => {
    updatePagination(swiper);
    onSlideChange?.(swiper);
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsx(
      Swiper,
      {
        modules: [Pagination, Navigation, Keyboard, A11y],
        a11y: {
          paginationBulletMessage: "{{index}}번 슬라이드로 이동"
        },
        pagination: {
          ...pagination ? pagination : {},
          clickable: true,
          el: multiId ? `.swiper-bullets.${multiId}` : `.swiper-bullets`,
          renderBullet: (index, className2) => {
            return `<button
                                    type="button"
                                    class="${className2}"
                                    aria-label="${index + 1}번 슬라이드"
                                ></button>`;
          }
        },
        onAfterInit: updatePagination,
        onSlideChange: handleSlideChange,
        className: cn("swiper-basic w-full", className, multiId),
        navigation: {
          prevEl: multiId ? `.swiper-btn-prev.${multiId}` : ".swiper-btn-prev",
          nextEl: multiId ? `.swiper-btn-next.${multiId}` : ".swiper-btn-next"
        },
        spaceBetween: 16,
        autoHeight: true,
        keyboard: { enabled: true },
        ...props,
        children
      }
    ),
    showNavigation && /* @__PURE__ */ jsxs("div", { className: "swiper-navigation mt-[14px]", children: [
      isDesktop && /* @__PURE__ */ jsx(
        "button",
        {
          className: multiId ? `swiper-btn-prev ${multiId}` : "swiper-btn-prev",
          title: "이전 슬라이드",
          children: /* @__PURE__ */ jsx(LineIcon, { icoName: "ico-caret-left", type: "xs" })
        }
      ),
      /* @__PURE__ */ jsx("div", { className: multiId ? `swiper-bullets ${multiId}` : "swiper-bullets" }),
      isDesktop && /* @__PURE__ */ jsx(
        "button",
        {
          className: multiId ? `swiper-btn-next ${multiId}` : "swiper-btn-next",
          title: "다음 슬라이드",
          children: /* @__PURE__ */ jsx(LineIcon, { icoName: "ico-caret-right", type: "xs" })
        }
      )
    ] })
  ] });
};

export { AccessibleSwiper };
